import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const openButtonCss = "o1msrq9s";
const OpenButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(openButtonCss, props.className)} />);
const closeButtonCss = "c1k30hsd";
const CloseButton = forwardRef((props, ref) => <OpenButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)} />);
export const MenuButton = ({
  children,
  isOpen,
  onClick,
  disabled,
  ...props
}) => {
  const ButtonComponent = isOpen ? CloseButton : OpenButton;
  return <ButtonComponent disabled={disabled} onClick={onClick} {...props}>{children}</ButtonComponent>;
};

require("./menu_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./menu_button.js");